module.exports = __webpack_public_path__ + "static/media/listcontrols.c3e05957.jpg";